var filtering = {
	// selectors: { },

	init: function () {
		var self = this;

		self.loadfiltering();
		

		function removeExpiredTiles() {
			function parseDate(dateStr) {
				let parts = dateStr.split('-');
				return new Date(parts[2], parts[1] - 1, parts[0]);
			}
			const currentDate = new Date();
			currentDate.setHours(0, 0, 0, 0);
			const elements = document.querySelectorAll('.tile-switching[data-limitedend], .js-allowProductsFilterByDates .product[data-limitedend], .filter-event[data-limitedend], .product[data-limitedend]');
			
			if( elements.length == 0 ) return false;

			elements.forEach(element => {
				const limitedEndDate = parseDate(element.getAttribute('data-limitedend'));
				if (limitedEndDate < currentDate) {
					element.remove();
				}
			});
		}

		removeExpiredTiles();

		
		if( document.querySelector('.js-pagination') ) {

			const filtersModal = document.querySelector('.filters-modal');
			let articles = document.querySelectorAll('.tile-switching, .js-allowProductsFilterByDates .products .product');
			const paginationContainer = document.querySelector('.js-pagination');
			const loadMoreButton = document.querySelector('.js-load-more');
			const articleCountSpan = document.querySelector('.section-cols-heading h2 strong');
			const openFiltersButton = document.querySelector('.js-openFilters');
			const resetFiltersButton = document.querySelector('[data-js-clear-all]');
			const dateRangePicker = jQuery('#events_range');
			
			let currentPage = 1;
			const articlesPerPage = 20;
			let minLoadedPage = 1;
			let maxLoadedPage = 1;
			let startDate = null;
			let endDate = null;
			let selectedFilters = {};
			
			// Načti hodnoty z URL a apply filtr
			function loadFromURL() {
				const urlParams = new URLSearchParams(window.location.search);
				const filterParams = {};
				for (const [key, value] of urlParams.entries()) {
					if (key.startsWith('f_')) {
						filterParams[key] = value.split(',');
						document.querySelectorAll(`input[name="${key}[]"]`).forEach(input => {
							input.checked = filterParams[key].includes(input.value);
						});
					} else if (key === 'pg') {
						currentPage = parseInt(value);
						minLoadedPage = currentPage;
						maxLoadedPage = currentPage;
					} else if (key === 'start_date') {
						startDate = value;
						if (dateRangePicker.data('daterangepicker')) {
							dateRangePicker.data('daterangepicker').setStartDate(moment(startDate, 'DD-MM-YYYY'));
						}
					} else if (key === 'end_date') {
						endDate = value;
						if (dateRangePicker.data('daterangepicker')) {
							dateRangePicker.data('daterangepicker').setEndDate(moment(endDate, 'DD-MM-YYYY'));
						}
					}
				}
				filterArticles();
			}
			
			window.addEventListener('popstate', () => {
				loadFromURL();
			});
			
			if (dateRangePicker.length) {
				dateRangePicker.on('apply.daterangepicker', function(ev, picker) {
					startDate = picker.startDate.format('DD-MM-YYYY');
					endDate = picker.endDate.format('DD-MM-YYYY');
					filterArticles();
				});
			
				dateRangePicker.on('cancel.daterangepicker', function(ev, picker) {
					startDate = null;
					endDate = null;
					filterArticles();
				});
			}
			
			function filterArticles() {
				articles = document.querySelectorAll('.tile-switching, .js-allowProductsFilterByDates .products .product');
				const selectedFilters = getSelectedFilters();
				articles.forEach(article => article.classList.remove('filtered-active'));
				const filteredArticles = Array.from(articles).filter(article => {
					const articleDates = article.dataset.event_date ? article.dataset.event_date.split(',') : [];
					const isDateInRange = startDate && endDate ? articleDates.includes('all') || articleDates.some(date => {
						const dateMoment = moment(date, 'DD-MM-YYYY');
						return dateMoment.isBetween(moment(startDate, 'DD-MM-YYYY'), moment(endDate, 'DD-MM-YYYY'), null, '[]');
					}) : true;
			
					if (isDateInRange && Object.keys(selectedFilters).every(key => {
						if(  article.dataset[key] == undefined ) { return; }
						const articleValues = article.dataset[key].split(',');
						return selectedFilters[key].every(value => articleValues.includes(value));
					})) {
						article.classList.add('filtered-active');
						return true;
					}
					return false;
				});


				//===== hledání data u akcí =====
				filteredArticles.forEach(article => {
					if (!article.querySelector("[data-datesjson]")) { return; }
				
					let datesJson = article.querySelector(".js-openEventDates[data-datesjson]").getAttribute('data-datesjson');
					if (datesJson != null) {
						const datesArray = JSON.parse(datesJson.replace(/&quot;/g, '"'));
				
						const upcomingDates = datesArray
							.map(dateRange => {
								const [day, month, year] = dateRange[0].split(" ")[0].split("-");
								const time = dateRange[0].split(" ")[1];
								const date = moment(`${day}-${month}-${year} ${time}`, 'DD-MM-YYYY HH:mm');
								
								return { original: dateRange, date }; // Uložíme celou řadu `dateRange` jako `original`
							})
							.filter(({ date }) => {
								const isValid = date.isValid();
								const isInRange = date.isBetween(moment(startDate, 'DD-MM-YYYY'), moment(endDate, 'DD-MM-YYYY'), 'day', '[]');
								return isValid && isInRange;
							})
							.sort((a, b) => a.date - b.date);
						
						if (upcomingDates.length > 0) {
							const nearestDateRange = upcomingDates[0].original;
							const [startDate, endDate] = nearestDateRange;
				
							// Formátujeme data přes moment.js pro správný výstup
							let formattedStartDate = moment(startDate, 'DD-MM-YYYY HH:mm').format('D. M. YYYY, HH:mm');
							let formattedEndDate = moment(endDate, 'DD-MM-YYYY HH:mm').format('D. M. YYYY, HH:mm');

							if( moment(startDate, 'DD-MM-YYYY HH:mm').format('D. M. YYYY') == moment(endDate, 'DD-MM-YYYY HH:mm').format('D. M. YYYY') ) {
								formattedEndDate = moment(endDate, 'DD-MM-YYYY HH:mm').format('HH:mm');
							}

							formattedStartDate = formattedStartDate.replaceAll( ', 00:00', '' ).replaceAll( ', 23:59', '' );
							formattedEndDate = formattedEndDate.replaceAll( ', 00:00', '' ).replaceAll( ', 23:59', '' );
							formattedEndDate = formattedStartDate == formattedEndDate ? '' : "–" + formattedEndDate;
				
							article.querySelector("h2 + p").textContent = `${formattedStartDate}${formattedEndDate}`;
						}
					}
				});
				


				//===== řazení a úprava dat u produktů=====
				filteredArticles.sort((a, b) => {
					const aPriority = a.dataset.priority === "1";
					const bPriority = b.dataset.priority === "1";
				
					if (aPriority && bPriority) {
						const aOrder = parseInt(a.dataset.order, 10) || 0;
						const bOrder = parseInt(b.dataset.order, 10) || 0;
						return aOrder - bOrder;
					}
				
					if (aPriority) return -1;
					if (bPriority) return 1;
			
					const aDatesRaw = a.dataset.event_date ? a.dataset.event_date.split(',') : [];
					const bDatesRaw = b.dataset.event_date ? b.dataset.event_date.split(',') : [];
				
					const aDates = aDatesRaw.map(date => moment(date, 'DD-MM-YYYY')).filter(date => {
						const isValid = date.isValid();
						const isInRange = date.isBetween(moment(startDate, 'DD-MM-YYYY'), moment(endDate, 'DD-MM-YYYY'), null, '[]');
						return isValid && isInRange;
					});
				
					const bDates = bDatesRaw.map(date => moment(date, 'DD-MM-YYYY')).filter(date => {
						const isValid = date.isValid();
						const isInRange = date.isBetween(moment(startDate, 'DD-MM-YYYY'), moment(endDate, 'DD-MM-YYYY'), null, '[]');
						return isValid && isInRange;
					});
				
					const aFirstDate = aDates.length > 0 ? aDates[0] : moment('9999-12-31', 'YYYY-MM-DD');
					const bFirstDate = bDates.length > 0 ? bDates[0] : moment('9999-12-31', 'YYYY-MM-DD');
				
					if (aFirstDate.isBefore(bFirstDate)) {
						return -1;
					} else if (aFirstDate.isAfter(bFirstDate)) {
						return 1;
					} else {
						return 0;
					}
				});
				
				let container = document.querySelector('.products, .switching-list');
				if (container) {
					filteredArticles.forEach(article => {
						container.appendChild(article);
					});
				}


				filteredArticles.forEach(article => {
					if( !article.querySelector(".product__dates") ) {
						return;
					}
					
					let soldOutDateButHaveMore = false;
					const productDates = article.querySelector(".product__dates").dataset.product_dates ? JSON.parse(article.querySelector(".product__dates").dataset.product_dates.replace(/&quot;/g, '"')) : [];
					if( !productDates.length ) {
						return;
					}

					if( productDates.length > 1 ) {
						jQuery.each( productDates, function( index, event ) {
							if( index == 0 && event[ 'spots' ] > 0 ) {
								return; // break;
							}

							if( index > 0 && event[ 'spots' ] > 0 ) {
								soldOutDateButHaveMore = true;
								return; // break;
							}
						});
					}

					const adjustedEndDate = moment(endDate, 'DD-MM-YYYY').endOf('day');

					//const matchingDate = productDates.find(pd => moment(pd.date, 'YYYY-MM-DD HH:mm').isBetween(moment(startDate, 'DD-MM-YYYY'), adjustedEndDate, null, '[]'));
					
					let matchingDate = productDates.find(pd => moment(pd.date, 'YYYY-MM-DD HH:mm').isBetween(moment(startDate, 'DD-MM-YYYY'), adjustedEndDate, null, '[]'));

					if (!matchingDate) {
						matchingDate = productDates[productDates.length - 1];
					}

					if (matchingDate) {
						const dateElement = article.querySelector('.product__dates span');
						const stockElement = article.querySelector('.stock');

						if (dateElement) {
							dateElement.textContent = matchingDate.date_formatted;
						}

						if( stockElement ) {
							let itemStockText = matchingDate.spots == 0 ? `${pctVars.l18n.booking.state[1]}` : `${pctVars.l18n.booking.state[0]} ${matchingDate.spots}`;

							if( matchingDate.spots == 0 && soldOutDateButHaveMore ) {
								itemStockText = pctVars.l18n.booking.state[3]; 
							}

							if( ! matchingDate.status ) {
								itemStockText = pctVars.l18n.booking.state[2];
							}

							stockElement.textContent =  itemStockText;
						}
					}
				});
		
				//=======

			
				if (filteredArticles.length === 0) {
					//console.log('No results found.');
				}
			
				const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);
				if (currentPage > totalPages) {
					currentPage = totalPages;
				}
				if (currentPage < 1) {
					currentPage = 1;
				}
			
				minLoadedPage = currentPage;
				maxLoadedPage = currentPage;
			
				articleCountSpan.textContent = `(${filteredArticles.length})`;
			
				let get_articles = document.querySelectorAll('.tile-switching, .js-allowProductsFilterByDates .products .product');
				let filterArticles = Array.from(get_articles).filter(article => article.classList.contains('filtered-active'));

				showArticles(filterArticles);
				updatePagination(filterArticles.length, totalPages);
				updateURL(selectedFilters, currentPage, startDate, endDate, false);
				filterMapMarkers();
			
				// Update data-count attribute
				const filterTypesCount = Object.keys(selectedFilters).length;
				if( openFiltersButton ) {
					openFiltersButton.setAttribute('data-count', filterTypesCount);
				}
			}
			
			function getSelectedFilters() {
				const selectedFilters = {};
				if( filtersModal ) {
					filtersModal.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(input => {
						const name = input.name.replace('[]', '');
						if (!selectedFilters[name]) {
							selectedFilters[name] = [];
						}
						selectedFilters[name].push(input.value);
					});
				}
				return selectedFilters;
			}
			
			function filterMapMarkers() {
				document.querySelectorAll('[data-map-poid]').forEach(el => el.classList.remove('active'));
				document.querySelectorAll('.tile-switching.filtered-active').forEach(tile => {
					document.querySelectorAll(`[data-map-poid="${tile.dataset.poid}"]`).forEach(el => el.classList.add('active'));
				});
			}
			
			function showArticles(filteredArticles) {
				// console.log( filteredArticles );
				// console.log( articles );
				articles = document.querySelectorAll('.tile-switching, .js-allowProductsFilterByDates .products .product');
				articles.forEach(article => article.classList.remove('active'));

				//let filteredActiveArticles = filteredArticles.length ? filteredArticles : Array.from(articles); // Display all articles if no filters are applied
				let filteredActiveArticles = filteredArticles;
				const start = (minLoadedPage - 1) * articlesPerPage;
				const end = maxLoadedPage * articlesPerPage;



			//	const selectedFilters = getSelectedFilters();

			// const filtersModal = document.querySelector('.filters-modal');
			// const articles = document.querySelectorAll('.tile-switching, .js-allowProductsFilterByDates .products .product');
			// const paginationContainer = document.querySelector('.js-pagination');
			// const loadMoreButton = document.querySelector('.js-load-more');
			// const articleCountSpan = document.querySelector('.section-cols-heading h2 strong');
			// const openFiltersButton = document.querySelector('.js-openFilters');
			// const resetFiltersButton = document.querySelector('[data-js-clear-all]');
			// const dateRangePicker = jQuery('#events_range');
			
			// let currentPage = 1;
			// const articlesPerPage = 20;
			// let minLoadedPage = 1;
			// let maxLoadedPage = 1;
			// let startDate = null;
			// let endDate = null;
				if( dateRangePicker && !startDate  || !endDate) {

				}

				filteredActiveArticles.slice(start, end).forEach(article => article.classList.add('active'));
			
				if (end >= filteredActiveArticles.length) {
					loadMoreButton.disabled = true;
					loadMoreButton.classList.add('disabled');
				} else {
					loadMoreButton.disabled = false;
					loadMoreButton.classList.remove('disabled');
				}
			}
			
			//pagination
			function updatePagination(totalArticles, totalPages) {
				paginationContainer.innerHTML = '';
			
				const prevLi = document.createElement('li');
				prevLi.classList.add('prev');
				const prevA = document.createElement('a');
				prevA.href = '#';
				prevA.textContent = 'Prev';
				if (currentPage === 1) {
					prevLi.classList.add('d-none');
				}
				prevA.addEventListener('click', (event) => {
					event.preventDefault();
					if (currentPage > 1) {
						currentPage--;
						minLoadedPage = currentPage;
						maxLoadedPage = currentPage;
						updatePaginationAndArticles();
					}
				});
				prevLi.appendChild(prevA);
				paginationContainer.appendChild(prevLi);
			
				let addedLeftDots = false;
				let addedRightDots = false;
			
				for (let i = 1; i <= totalPages; i++) {
					if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) {
						const li = document.createElement('li');
						const a = document.createElement('a');
						a.href = '#';
						a.textContent = i;
						li.appendChild(a);
			
						if (i === currentPage) {
							li.classList.add('active');
						} else if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) {
							li.classList.add('next-to-active');
						} else {
							li.classList.add('d-none');
						}
			
						a.addEventListener('click', (event) => {
							event.preventDefault();
							currentPage = i;
							minLoadedPage = i;
							maxLoadedPage = i;
							updatePaginationAndArticles();
						});
			
						paginationContainer.appendChild(li);
					} else if (i < currentPage - 2 && !addedLeftDots) {
						const dotsLi = document.createElement('li');
						dotsLi.textContent = '...';
						paginationContainer.appendChild(dotsLi);
						addedLeftDots = true;
					} else if (i > currentPage + 2 && !addedRightDots) {
						const dotsLi = document.createElement('li');
						dotsLi.textContent = '...';
						paginationContainer.appendChild(dotsLi);
						addedRightDots = true;
					}
				}
			
				const nextLi = document.createElement('li');
				nextLi.classList.add('next');
				const nextA = document.createElement('a');
				nextA.href = '#';
				nextA.textContent = 'Next';
				if (currentPage === totalPages || totalPages === 0) {
					nextLi.classList.add('d-none');
				}
				nextA.addEventListener('click', (event) => {
					event.preventDefault();
					if (currentPage < totalPages) {
						currentPage++;
						minLoadedPage = currentPage;
						maxLoadedPage = currentPage;
						updatePaginationAndArticles();
					}
				});
				nextLi.appendChild(nextA);
				paginationContainer.appendChild(nextLi);
			}
			
			function updatePaginationAndArticles( moveToTop = true ) {
				articles = document.querySelectorAll('.tile-switching, .js-allowProductsFilterByDates .products .product');
				const selectedFilters = getSelectedFilters();
				articles.forEach(article => article.classList.remove('active'));
				const filteredArticles = Array.from(articles).filter(article => article.classList.contains('filtered-active'));
				const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);
				showArticles(filteredArticles);
				updatePagination(filteredArticles.length, totalPages);
				updateURL(selectedFilters, currentPage, startDate, endDate, true);

				if( moveToTop ) {
					jQuery('html, body').animate({
						scrollTop: jQuery('#filtered-listing').offset().top
					}, 500 );  // 1000 milliseconds = 1 second
				}
			
				// Update data-count attribute
				const filterTypesCount = Object.keys(selectedFilters).length;
				if( openFiltersButton ) {
					openFiltersButton.setAttribute('data-count', filterTypesCount);
				}
			}
			
			function updateURL(filters, page, startDate, endDate, addHistory = false) {
				const params = new URLSearchParams(window.location.search);
				for (const key of Array.from(params.keys())) {
					if (key.startsWith('f_') || key === 'pg' || key === 'start_date' || key === 'end_date') {
						params.delete(key);
					}
				}

				Object.keys(filters).forEach(key => {
					params.set(key, filters[key].join(','));
				});
				params.set('pg', page);
				if (startDate) params.set('start_date', startDate);
				if (endDate)   params.set('end_date', endDate);

				const newURL = '?' + params.toString();
				if (addHistory) {
					history.pushState(null, '', newURL);
				} else {
					history.replaceState(null, '', newURL);
				}
			}
			
			loadMoreButton.addEventListener('click', (event) => {
				articles = document.querySelectorAll('.tile-switching, .js-allowProductsFilterByDates .products .product');
				event.preventDefault();
				maxLoadedPage++;
				currentPage = maxLoadedPage; // Synchronizace currentPage s maxLoadedPage
				const selectedFilters = getSelectedFilters();
				const filteredArticles = Array.from(articles).filter(article => article.classList.contains('filtered-active'));
				showArticles(filteredArticles);
				const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);
				updatePagination(filteredArticles.length, totalPages);
				updateURL(selectedFilters, maxLoadedPage, startDate, endDate, true);
			
				// Synchronizace paginace po kliknutí na "Load More"
				const activePage = paginationContainer.querySelector('.active');
				if (activePage) activePage.classList.remove('active');
				const newActivePage = paginationContainer.querySelector(`li:nth-child(${maxLoadedPage + 1})`);
				if (newActivePage) newActivePage.classList.add('active');
				updatePaginationAndArticles( false );
			});
			
			if( filtersModal.length ) {
				if( filtersModal.querySelector('button[type="submit"]').length ) {
					filtersModal.querySelector('button[type="submit"]').addEventListener('click', (event) => {
						event.preventDefault();
						filterArticles();
						const selectedFilters = getSelectedFilters();
						updateURL(selectedFilters, currentPage, startDate, endDate, true);
						jQuery.fancybox.close();
					});
				}
			} 
			
			// Reset filters
			if( resetFiltersButton ) {
				resetFiltersButton.addEventListener('click', (event) => {
					articles = document.querySelectorAll('.tile-switching, .js-allowProductsFilterByDates .products .product');
					event.preventDefault();
					filtersModal.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => {
						input.checked = false;
					});
					if (dateRangePicker.length) {
						dateRangePicker.data('daterangepicker').setStartDate(moment());
						dateRangePicker.data('daterangepicker').setEndDate(moment());
					}
					startDate = null;
					endDate = null;
					// Reset URL and reload all articles
					updateURL({}, 1, null, null, true);
					currentPage = 1;
					minLoadedPage = 1;
					maxLoadedPage = 1;
					articles.forEach(article => article.classList.remove('filtered-active'));
					articles.forEach(article => article.classList.add('filtered-active')); // Ensure all articles are marked as filtered-active
					showArticles(Array.from(articles));
					updatePagination(articles.length, Math.ceil(articles.length / articlesPerPage));
					openFiltersButton.setAttribute('data-count', 0);
					filterMapMarkers();
					filterArticles();
					jQuery.fancybox.close();
				});
			}
				
			loadFromURL();
			
		}			
		
	},

	loadfiltering: function() {
		var self = this;

	},
};

export { filtering };